{
	"title": "Komentáře",
	"statuses": {
		"inValidation": "Ve validaci",
		"rejected": "Odmítnuto",
		"assured": "Zajištěno",
		"flagged": "Označeno",
		"resolved": "Vyřešeno"
	}
}
